<script>
import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import {
	getGeneralDetails,
	updateGeneralDetails,
} from "../../../../api/services/cms.service";
import { getS3SingedUrl } from "../../../../api/services/general.service";
/**
 * Manage General Page
 */
export default {
	page: {
		title: "Allgemein Verwalten",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
		PageHeader,
	},
	data() {
		return {
			title: this.$i18n.t("CMS.generalPage.manageGeneralPage"),
			items: [
				{
					text: this.$i18n.t("CMS.generalPage.manageGeneralPage"),
					active: true,
				},
			],
			allGeneral: null,
			id: null,
			email: null,
			telephone: null,
			address: null,
			footer_description: null,
			imprintPdfURL: null,
			dataProtectionPdfURL: null,
			agbPdfURL: null,
			imprintPdfName: null,
			imprintPdf: null,
			dataProtectionPdf: null,
			agbPdf: null,
			dataProtectionPdfName: null,
			agbPdfName: null,
			isUpdating: false,
		};
	},
	validations: {
		email: { required, email },
		telephone: { required },
		address: { required },
		footer_description: { required },
	},
	async mounted() {
		this.getAllGeneral();
	},
	methods: {
		async getAllGeneral() {
			let getAllGeneralFunction = await getGeneralDetails();
			this.allGeneral = getAllGeneralFunction[0];
			if (this.allGeneral) {
				this.email = this.allGeneral.email;
				this.telephone = this.allGeneral.phone;
				this.address = this.allGeneral.address;
				this.footer_description = this.allGeneral.footer_description;

				this.imprintPdfURL = this.allGeneral.doc_imprint;
				this.imprintPdfName = this.imprintPdfURL.split("/").slice(-1)[0];

				this.dataProtectionPdfURL = this.allGeneral.doc_dataProtection;
				this.dataProtectionPdfName = this.dataProtectionPdfURL
					.split("/")
					.slice(-1)[0];

				this.agbPdfURL = this.allGeneral.doc_termsAndConditions;
				this.agbPdfName = this.agbPdfURL.split("/").slice(-1)[0];

				this.id = this.allGeneral.id;
			}
		},
		clickCloseButton() {
			this.$emit("reload");
		},
		async clickSaveButton() {
			this.isUpdating = true;
			if (this.imprintPdf) {
				this.imprintPdfURL = await this.getS3PresignedUrl(this.imprintPdf);
			}

			if (this.agbPdf) {
				this.agbPdfURL = await this.getS3PresignedUrl(this.agbPdf);
			}
			if (this.dataProtectionPdf) {
				this.dataProtectionPdfURL = await this.getS3PresignedUrl(
					this.dataProtectionPdf
				);
			}

			const updateGeneral = {
				email: this.email,
				phone: this.telephone,
				address: this.address,
				footer_description: this.footer_description,
				doc_imprint: this.imprintPdfURL,
				doc_dataProtection: this.dataProtectionPdfURL,
				doc_termsAndConditions: this.agbPdfURL,
				coverImage: this.allGeneral.coverImage,
				headerImage: this.allGeneral.headerImage,
			};

			await updateGeneralDetails(this.id, updateGeneral);
			this.realodPage();
		},
		async getS3PresignedUrl(file) {
			const fileName = file.name;
			let getUploadedFileURL = await getS3SingedUrl(fileName);

			let getFileUploadResponse = await axios.put(
				getUploadedFileURL.signedUrl,
				file
			);

			let fileBaseUrl =
				"https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";

			if (getFileUploadResponse) {
				return encodeURI(fileBaseUrl + fileName);
			}
			return null;
		},
		agbFileSelected() {
			this.agbPdf = this.$refs.agbPDFInput.files[0];
			this.agbPdfName = this.$refs.agbPDFInput.files[0].name;
		},
		dataPolicyFileSelected() {
			this.dataProtectionPdf = this.$refs.datapolicyPDFInput.files[0];
			this.dataProtectionPdfName = this.$refs.datapolicyPDFInput.files[0].name;
		},
		imprintPdfFileSelected() {
			this.imprintPdf = this.$refs.imprintPDFInput.files[0];
			this.imprintPdfName = this.$refs.imprintPDFInput.files[0].name;
		},
		realodPage() {
			window.location.reload();
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-md-12">
				<div class="card pb-3">
					<div class="card-body">
						<div class="card-title">
							{{ $t("CMS.generalPage.manageContactDetials") }}
						</div>
						<div class="row mt-3">
							<div class="col-md-4">
								<label>
									{{ $t("CMS.generalPage.emailLabel") }}
									<span class="text-danger">*</span>
								</label>
								<b-form-group>
									<b-form-input
										v-model="email"
										:placeholder="
											this.$i18n.t('CMS.generalPage.emailPlaceholder')
										"
										:class="{ 'is-invalid': $v.email.$error }"
									></b-form-input>
								</b-form-group>
								<div v-if="$v.email.$error" class="invalid-feedback">
									<span v-if="$v.email.$error && !$v.email.required">{{
										$t("CMS.generalPage.emailRequired")
									}}</span>
									<span v-if="$v.email.$error && !$v.email.email">{{
										$t("CMS.generalPage.emailValid")
									}}</span>
								</div>
							</div>
							<div class="col-md-4">
								<label>
									{{ $t("CMS.generalPage.telephoneLabel") }}
									<span class="text-danger">*</span>
								</label>
								<b-form-group>
									<b-form-input
										v-model="telephone"
										:placeholder="
											this.$i18n.t('CMS.generalPage.telephonePlaceholder')
										"
										:class="{ 'is-invalid': $v.telephone.$error }"
									></b-form-input>
								</b-form-group>
								<div v-if="$v.telephone.$error" class="invalid-feedback">
									<span v-if="$v.telephone.$error && !$v.telephone.required">{{
										$t("CMS.generalPage.telephoneRequired")
									}}</span>
								</div>
							</div>
							<div class="col-md-4">
								<label>
									{{ $t("CMS.generalPage.addressLabel") }}
									<span class="text-danger">*</span>
								</label>
								<b-form-group>
									<b-form-input
										v-model="address"
										:placeholder="
											this.$i18n.t('CMS.generalPage.addressPlaceholder')
										"
										:class="{ 'is-invalid': $v.address.$error }"
									></b-form-input>
								</b-form-group>
								<div v-if="$v.address.$error" class="invalid-feedback">
									<span v-if="$v.address.$error && !$v.address.required">{{
										$t("CMS.generalPage.addressRequired")
									}}</span>
								</div>
							</div>
							<div class="col-md-4 mt-3">
								<label>
									{{ $t("CMS.generalPage.footerDescriptionLabel") }}
									<span class="text-danger">*</span>
									<span class="ml-2">
										<p
											v-if="footer_description"
											class="badge position-absolute"
											:class="{
												'badge-light': footer_description.length !== 170,
												'badge-danger': footer_description.length === 170,
											}"
										>
											{{ footer_description.length }} / 170
										</p>
									</span>
								</label>
								<textarea
									v-model="footer_description"
									class="form-control"
									name="textarea"
									rows="5"
									:maxlength="170"
									:placeholder="
										this.$i18n.t('CMS.generalPage.footerDescriptionPlaceholder')
									"
									:class="{ 'is-invalid': $v.footer_description.$error }"
								></textarea>
								<div
									v-if="$v.footer_description.$error"
									class="invalid-feedback"
								>
									<span
										v-if="
											$v.footer_description.$error &&
												!$v.footer_description.required
										"
										>{{ $t("CMS.generalPage.footerDescriptionRequired") }}</span
									>
								</div>
							</div>
							<div class="col-md-8 mt-3">
								<div class="row">
									<div class="col-md-4">
										<div class="">
											{{ $t("CMS.generalPage.imprintLabel") }}
											<span>
												<input
													id="imprintPDFInput"
													ref="imprintPDFInput"
													type="file"
													name="file"
													accept="application/pdf"
													style="width: 0.1px; opacity: 0; z-index: -1"
													@change="imprintPdfFileSelected()"
												/>
												<span>
													<label
														for="imprintPDFInput"
														class="text-info"
														style="cursor: pointer"
													>
														<i
															class="bx bxs-message-square-edit text-warning"
														></i>
													</label>
												</span>
											</span>
										</div>
										<div class="mt-2">
											<img
												src="@/assets/images/pdf.png"
												alt
												class="avatar-md img-thumbnail"
											/>
										</div>
										<div class="mt-2">{{ imprintPdfName }}</div>
									</div>
									<div class="col-md-4">
										<div>
											{{ $t("CMS.generalPage.dataPolicyLabel") }}
											<span>
												<input
													id="datapolicyPDFInput"
													ref="datapolicyPDFInput"
													type="file"
													name="file"
													accept="application/pdf"
													style="width: 0.1px; opacity: 0; z-index: -1"
													@change="dataPolicyFileSelected()"
												/>
												<span>
													<label
														for="datapolicyPDFInput"
														class="text-info"
														style="cursor: pointer"
													>
														<i
															class="bx bxs-message-square-edit text-warning"
														></i>
													</label>
												</span>
											</span>
										</div>
										<div class="mt-2">
											<img
												src="@/assets/images/pdf.png"
												alt
												class="avatar-md img-thumbnail"
											/>
										</div>
										<div class="mt-2">{{ dataProtectionPdfName }}</div>
									</div>
									<div class="col-md-4">
										<div>
											{{ $t("CMS.generalPage.agbLabel") }}
											<span>
												<input
													id="agbPDFInput"
													ref="agbPDFInput"
													type="file"
													name="file"
													accept="application/pdf"
													style="width: 0.1px; opacity: 0; z-index: -1"
													@change="agbFileSelected()"
												/>
												<span>
													<label
														for="agbPDFInput"
														class="text-info"
														style="cursor: pointer"
													>
														<i
															class="bx bxs-message-square-edit text-warning"
														></i>
													</label>
												</span>
											</span>
										</div>
										<div class="mt-2">
											<img
												src="@/assets/images/pdf.png"
												alt
												class="avatar-md img-thumbnail"
											/>
										</div>
										<div class="mt-2">{{ agbPdfName }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3">
			<b-button
				variant="success"
				@click="clickSaveButton()"
				:disabled="isUpdating"
			>
				<i class="bx bxs-save mr-1"></i>
				{{ $t("general.buttons.save") }}</b-button
			>
		</div>
	</Layout>
</template>

<style scoped>
.text-limted-one-lines {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1; /* number of lines to show */
	-webkit-box-orient: vertical;
}
.text-limted-two-lines {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2; /* number of lines to show */
	-webkit-box-orient: vertical;
}

.extra-image-preview-after-crop {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: none;
	width: 120px;
	height: 120px;
	padding: 0;
	margin: 0;
}
</style>
